import { REACT_APP_API } from '../../config'
import axios from 'axios'

export async function getRequest(requestsId) {
    try {
        const response = await axios.get(`${REACT_APP_API}/api/requests/getSummaryById/${requestsId}`)
        if (response.status === 200) {
            return response.data
        }
        return null
    } catch (error) {
        console.log(`Error getRequest `, error)
        return error
    }

}